import { defineStore } from 'pinia'

/**
 * 路由缓存（keep-alive）状态：
 * - cachedViews：当前被缓存的列表页组件名（与路由 name、组件 defineOptions.name 一致），
 *   供 home.vue 的 <keep-alive :include> 使用
 * - pendingRefresh：下级编辑页标记的「返回列表需重新拉数据」（筛选/分页保持不变），
 *   由列表页 onActivated 时消费
 */
export const useRouteCacheStore = defineStore('routeCache', {
  state: () => ({
    cachedViews: [],
    pendingRefresh: {}
  }),
  actions: {
    addView(name) {
      if (name && !this.cachedViews.includes(name)) this.cachedViews.push(name)
    },
    delView(name) {
      this.cachedViews = this.cachedViews.filter((n) => n !== name)
      delete this.pendingRefresh[name]
    },
    delAllViews() {
      this.cachedViews = []
      this.pendingRefresh = {}
    },
    markRefresh(name) {
      if (name) this.pendingRefresh[name] = true
    },
    consumeRefresh(name) {
      if (!name || !this.pendingRefresh[name]) return false
      delete this.pendingRefresh[name]
      return true
    }
  }
})
